module.exports = __webpack_public_path__ + "static/media/bedFrame.85361546.jpg";